import { render, staticRenderFns } from "./ChinaEcharts.vue?vue&type=template&id=beaf7d9e"
import script from "./ChinaEcharts.vue?vue&type=script&lang=js"
export * from "./ChinaEcharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports